<template>
	<div class="wholesubmit ">
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>订单提交</span>
			<span></span>
		</div>
		<div style="height: 2rem;"></div>
		<div class="block" style="padding: 0.5rem 0 0.6rem 0;">
			<van-cell-group>
				<div class="qita">
					<div style="margin-right: 1.0625rem;width: 90px;">租赁方式</div>
					<van-radio-group v-model="time">
						<van-radio :name="item.id" checked-color="#ee0a24" icon-size="14px" @click="onChange()" v-for="(item,index) in list">{{item.title}}</van-radio>
					</van-radio-group>
				</div>
			</van-cell-group>
		</div>
		<div class="block">
			<div class="gouwuche">
				<div style="font-weight: bold; text-align: left; font-size: 0.875rem; padding-bottom: 0.375rem;">请确认您的配置需求列表</div>
				<div v-for="(item,index) in gowuche.list" style="padding: 0.3rem 0;">
					<div class="titou">
						<div class="name">{{item.title}}</div>
						<div style="color: #2795EF; text-decoration:underline; " @click="gotu(item.id)">详情</div>
					</div>
					<div class="jiage" style="color: #F1452F;">￥{{item.price}}</div>
					<div class="jbq">
						{{item.num}}
					</div>
				</div>
			</div>
		</div>
		<div class="block">
			<div class="gouwuche">
				<div style="font-weight: bold; text-align: left; font-size: 0.875rem; padding-bottom: 0.375rem;">请填写您的联系信息</div>
				<div style="position: relative;">
					<van-field v-model="address" readonly type="text" label="所在地区" placeholder="请选择所在地区" @click="select=true"></van-field>
					<div slot="right-icon" style="display:flex;align-items:center;color:#F1452F; position: absolute; top: 0.3125rem; right: 0; z-index: 999;"
					 @click="showAds=true">
						<img src="../../assets/address.png" style="width:0.8rem" alt="">
						<div>&nbsp;当前位置</div>
					</div>
				</div>
				<van-field v-model="detailed" :border="false" label="项目地址" placeholder="请输入具体地址" />
				<van-field v-model="remarks" :border="false" label="备注信息" placeholder="请留下您的特别说明" />
				<van-field v-model="people" :border="false" label="联系人" placeholder="请输入联系人" />
				<van-field v-model="tel" @input="changetel" type="number" :border="false" label="联系电话" placeholder="请输入联系电话" />
				<van-field v-model="sms" clearable placeholder="手机验证码" label="验证码">
					<van-button slot="button" size="small" type="primary" :disabled="codes" @click="getcode">{{buttonMsg}}</van-button>
				</van-field>
			</div>
		</div>
		<div class="manei">
			<div style="line-height: 2.3125rem;">{{money.month_price}}</div>
			<div>
				<div>总价：<span style="color: #F1452F;">￥{{money.total}}</span></div>
				<div style="font-size: 12px;">（含可退押金：￥{{money.deposit}}）</div>
			</div>
		</div>
		<div style="height: 4rem;"></div>
		<van-goods-action>
			<van-goods-action-icon icon="home-o" text="首页" to="/home" />
			<van-goods-action-icon icon="chat-o" text="客服" @click="open53()" />
			<van-goods-action-button text="预约上门" type="warning" to="/yuyueshangmen" />
			<van-goods-action-button type="danger" text="立即支付" @click="place" />
		</van-goods-action>
		<van-popup v-model="select" position="bottom" :style="{ 'max-height': '80%' }">
			<van-area :area-list="areaList" @confirm="areaOk" @cancel="select=false" />
		</van-popup>
		<van-popup v-model="showAds" position="bottom" :style="{ 'height': '95%' }">
			<Map @close="close" @sites="sites"></Map>
		</van-popup>
		<!-- 选择支付方式 -->

		<van-popup v-model="show" position="bottom">
			<van-panel class="payment">
				<div slot="header" class="payment_header">
					支付方式
				</div>
				<div class="payment_content">
					<van-radio-group v-model="radio">
						<van-cell-group>
							<div class="pin">
								<van-cell title="微信支付" class="ptext" clickable @click="radio='1'">
									<div slot="icon" class="payment_icon">
										<img src="../../assets/wx.png" alt="">
									</div>
									<van-radio checked-color="#F1452F" icon-size="1rem" slot="right-icon" name="1" />
								</van-cell>
								<van-cell title="支付宝支付" class="ptext" clickable @click="radio='2'">
									<div slot="icon" class="payment_icon">
										<img src="../../assets/zfb.png" alt="">
									</div>
									<van-radio checked-color="#F1452F" icon-size="1rem" slot="right-icon" name="2" />
								</van-cell>
							</div>

						</van-cell-group>
					</van-radio-group>
					<div class="pays_btn">
						<button class="left-button" @click="duig=true">对公转账</button>
						<button class="right-button" @click="nextPay">立即付款</button>
					</div>
				</div>
			</van-panel>
		</van-popup>
		<!-- 对公转账 -->
		<van-popup v-model="duig" class="duig" position="bottom">
			<div class="duig-top">对公账户</div>
			<van-cell size="large">
				<div slot="title" class="duig-title">
					<div>开户名称：</div>
					<div>广州俱百家网络科技有限公司</div>
				</div>
			</van-cell>
			<van-cell size="large">
				<div slot="title" class="duig-title">
					<div>开户账户：</div>
					<div>3602073809100114062</div>
				</div>
			</van-cell>
			<van-cell size="large">
				<div slot="title" class="duig-title">
					<div>开户银行：</div>
					<div>中国工商银行广州泰沙路支行</div>
				</div>
			</van-cell>
			<div class="duig-foot">如果您付款成功，请在<span>会员中心</span>-<span>我的订单</span>-<span>待支付订单</span>中上传您的支付凭证，我们会第一时间核实并发货。若有问题请联系客服
				400-8722-000</div>
			<div class="duig-btn">
				<van-button round size="small" @click="sateway" style=" border: 1px solid #eee;">取消</van-button>
				<van-button round color="#f1452f" size="small" @click="place(1)" style=" border: 1px solid #f1452f;">提交订单</van-button>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import Map from '@/components/map';
	import areaList from "@/assets/js/area.js";

	export default {
		data() {
			return {
				radio: '1',
				value: '',
				list: '',
				select: false,
				areaList: areaList, // 数据格式见 Area 组件文档
				size: '',
				time: 8,
				people: '',
				tel: '',
				detailed: '',
				code: '',
				codes: false,
				remarks: '',
				arr: [],
				gowuche: '', // 已经选择的数据
				money: '',
				address: '',
				addressMsg: '',
				showAds: false,
				province: '', //省
				city: '', //市
				area: '', //区
				lat: '',
				lng: '',
				show: false,
				order_number: 0,
				buttonMsg: '获取验证码',
				sms: '',
				duig: false
			}
		},
		created() {
			// 判断有没有存入
			this.gowuche = JSON.parse(localStorage.getItem('whole'));
			for (var i = 0; i < this.gowuche.list.length; i++) {
				this.arr.push({
					id: this.gowuche.list[i].id,
					num: this.gowuche.list[i].num
				});
			}
			this.gat();
			this.onChange();
		},
		components: {
			Map
		},
		methods: {
			// 高德地图定位
			sites(e) {
				AMap.plugin('AMap.Geocoder', () => {
					// 这里通过高德 SDK 完成。
					var geocoder = new AMap.Geocoder({
						radius: 1000,
						extensions: "all"
					});
					geocoder.getAddress([e.location.lng, e.location.lat], (status, result) => {
						if (status === 'complete' && result.info === 'OK') {
							if (result && result.regeocode) {
								// 具体地址
								self.address = result.regeocode.formattedAddress;
								// 省
								self.province = result.regeocode.addressComponent.province;
								// 市
								self.city = result.regeocode.addressComponent.city;
								// 区
								self.district = result.regeocode.addressComponent.district;
								this.address = self.province + self.city + self.district;
								this.province = self.province;
								this.city = self.city;
								this.area = self.district;
							}
						} else {
							this.$toast('系统繁忙,请重试');
						}
					})
				});
				this.addressMsg = e.address;
				this.lat = e.location.lat;
				this.lng = e.location.lng;
				this.showAds = false;
			},
			//关闭选择地址
			close(res) {
				this.showAds = res;
			},
			//选中地址
			areaOk(event) {
				this.address = '';
				for (var item in event) {
					this.address += event[item].name;
				}
				this.select = false;
			},
			// 获取选项
			gat() {
				this.$axios.post(baseUrl + '/mobile/whole/wholelease').then((res) => {
					this.list = res.data.data
				}).catch((err) => {
					console.log(err);
				});
			},
			changetel(e) {
				if (e[0] != 1) {
					this.tel = '';
					// this.$toast('请正确填写您的手机号码');
					return false;
				}
			},
			// 选择数量 获取已经选择的数据
			onChange(id = '', num) {
				console.log(id,num)
				if (id != '') {
					for (var i = 0; i < this.arr.length; i++) {
						if (this.arr[i].id == id) {
							this.arr[i].num = num;
							if (this.arr[i].num == 0) {
								// this.arr.splice(i, 1)
							}
						} else {
							this.arr.push({
								id: id,
								num: num
							});
						}
					}

				}
				this.arr = this.unique(this.arr);
				var data = {
					lease_id: this.time,
					list: this.arr,
					area: this.size,
				};
				console.log(data)
				this.$axios.post(baseUrl + '/mobile/whole/mulit', data).then((res) => {
					this.money = res.data.data
					this.money.month_price = "月租金：￥" + this.money.count + "/月"
				}).catch((err) => {
					console.log(err);
				});
			},
			// 选择数量 获取已经选择的数据
			unique(array) {
				let obj = {}
				return array.filter((item, index) => {
					// 防止key重复
					let newItem = item + JSON.stringify(item)
					return obj.hasOwnProperty(newItem) ? false : obj[newItem] = true
				})
			},
			// 提交订单
			place(e) {
				var reg_tel = /^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/;
				if (this.people == '') {
					this.$toast('请输入联系人姓名');
					return false;
				};
				if (this.tel == '') {
					this.$toast('请输入联系人手机号码');
					return false;
				} else if (!reg_tel.test(this.tel)) {
					this.$toast('请正确填写您的手机号码');
					return false;
				}
				if (this.address == '') {
					this.$toast('请选择地址');
					return false;
				};
				if (this.detailed == '') {
					this.$toast('请输入详细地址');
					return false;
				};
				var obj = {
					lease_id: this.time,
					real_name: this.people,
					tel: this.tel,
					province: this.address,
					address: this.detailed,
					order_message: this.remarks,
					token: localStorage.getItem('Authorization'),
					sublist: this.arr,
					rent: this.money.rent, //租金
					mortgage_total: this.money.deposit, //押金
					total: this.money.total,
					month_total: this.money.count,
				}
				if (e == 1) {
					obj.is_channel = e
				}
				this.$axios.post(baseUrl + '/mobile/wholeorder/wholeOrderAdd', obj).then((res) => {
					if (res.data.code == 19) {
						this.order_number = res.data.data;
						this.show = true;
						if (e == 1) {
							this.$toast(res.data.msg);
							this.$router.push({
								path: '/wholeList'
							})
						}
						localStorage.removeItem('whole');
					} else {
						this.$toast(res.data.msg);
					}
				}).catch((err) => {
					console.log(err);
				});
			},
			// 跳转详情
			gotu(e) {
				this.$router.push({
					path: '/packlist',
					query: {
						id: e,
					}
				})
			},
			// 对公转账取消
			sateway() {
				this.duig = false;
				this.show = false;
			},
			// 获取验证码
			getcode() {
				if (this.tel === '') {
					this.$toast('请填写手机号');
					return false;
				} else if (this.tel && (!(/^[1][345789]\d{9}$/).test(this.tel) || !(/^[1-9]\d*$/).test(this.tel) ||
						this.tel.length !== 11)) {
					this.$toast('手机号码不符合规范');
					return false;
				} else {
					this.code = false
				}
				this.$axios.post(baseUrl + '/mobile/User/get_login_code', {
					tel: this.tel
				}).then((res) => {
					if (res.data.code == 2001) {
						this.$toast(res.data.msg);
						this.iphon = res.data.data.tel;
						this.codes = res.data.data.code;
						this.buttonMsg = 60;
						this.code = true
						var auth_timer = setInterval(() => {
							this.buttonMsg--;
							if (this.buttonMsg <= 0) {
								this.buttonMsg = '获取验证码'
								this.code = false
								clearInterval(auth_timer)
							}
						}, 1000)
					} else {
						this.$toast(res.data.msg);
					}
				}).catch((err) => {
					console.log(err);
				});
			},
			//继续支付
			nextPay() {
				var order_number = this.order_number;
				if (order_number) {
					if (this.radio == '1') {
						window.location.href = baseUrl + '/mobile/Pay/wholeWapWxPay?out_trade_no=' + order_number;
					} else if (this.radio == '2') {
						window.location.href = baseUrl + '/mobile/Pay/wholeWapPay?out_trade_no=' + order_number;
					} else {
						this.$toast('暂不支持');
					}
				} else {
					this.$toast('请先提交订单');
				}
			}
		}
	}
</script>

<style scoped>
	.wholesubmit .van-cell {
		padding: 0.5rem 0;
	}

	.wholesubmit .block {
		width: 94%;
		margin: auto;
		background-color: #fff;
		border-radius: 0.625rem;
		padding: 0.5rem 0 0.25rem 0;
		margin-top: 1.25rem;
	}

	.wholesubmit .border {
		border-bottom: 1px solid #eee;
		width: 90%;
		margin: auto;
	}

	.wholesubmit .qita {
		font-size: 14px;
		width: 90%;
		margin: auto;
		display: flex;
		margin-top: 0.6rem;
	}

	.wholesubmit .gouwuche {
		padding: 0 1rem;
		text-align: left;
		font-size: 0.8125rem;
		line-height: 1.875rem;
	}

	.wholesubmit .gouwuche>div {
		display: flex;
		justify-content: space-between;
		border-bottom: 1px solid #eee;
	}

	.wholesubmit .gouwuche>div:last-child {
		border: none;
	}

	.wholesubmit .gouwuche .titou {
		display: flex;
		justify-content: space-between;
		width: 50%;
	}

	.wholesubmit .gouwuche .titou .name {
		width: 80%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.wholesubmit .van-cell:not(:last-child)::after {
		border: none;
	}

	.wholesubmit .van-hairline--top-bottom:after {
		border-width: 0px 0px;
	}

	.wholesubmit .manei {
		display: flex;
		justify-content: space-between;
		width: 88%;
		margin: auto;
		border: 1px dotted #F1452F;
		border-radius: 0.625rem;
		background-color: #fff;
		margin-top: 1rem;
		padding: 0.375rem 3%;
		font-size: 14px;
	}

	.wholesubmit .qita .van-radio-group {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}


	.wholesubmit .qita .van-radio {
		flex: 0 0 40%;
		margin-bottom: 0.375rem;
	}

	.wholesubmit .payment .van-cell {
		padding: 1rem 1rem;
	}

	.wholesubmit .van-panel {
		width: 100%;
		font-size: 0.75rem;
		text-align: left;
		padding: 1rem;
		box-sizing: border-box;
		display: inline-block;
	}

	.wholesubmit .payment {
		padding: 0;
	}

	.wholesubmit .payment::after {
		border: 0;
	}

	.wholesubmit .payment .payment_header {
		border-bottom: 1px solid #ebedf0;
		padding: 1rem 1rem;
	}

	.wholesubmit .payment .payment_content .pays_btn {
		display: flex;
		justify-content: center;
		width: 93%;
		margin: auto;
	}

	.wholesubmit .payment .payment_content button {
		width: 80%;
		margin: 1rem 0;
		background: #e2e2e2;
		border: 0;
		outline: none;
		height: 2rem;
		line-height: 2rem;
		background: #F1452F;
		color: #fff;
	}

	.wholesubmit .payment .payment_content .left-button {
		background: linear-gradient(to right, #ffd01e, #ff8917);
		border-top-left-radius: 20px;
		border-bottom-left-radius: 20px;
	}

	.wholesubmit .payment .payment_content .right-button {
		border-top-right-radius: 20px;
		border-bottom-right-radius: 20px;
	}

	.wholesubmit .payment_content .van-cell,
	.wholesubmit .payment_icon {
		display: flex;
		align-items: center;
	}

	.wholesubmit .payment_icon img {
		width: 1.7rem;
		height: 1.7rem;
		margin-right: 0.5rem;
		object-fit: contain;
	}

	.wholesubmit .duig {
		border-radius: 0.5rem 0.5rem 0 0;
	}

	.wholesubmit .duig .van-cell {
		padding: 0.8rem 1rem;
		text-align: left;
		font-size: 0.8rem;
		box-sizing: border-box;
	}

	.wholesubmit .duig>div:nth-child(3) {
		padding: 0 1rem;
	}

	.wholesubmit .duig .van-cell .duig-title {
		font-size: 0.8rem;
		display: flex;
	}

	.wholesubmit .van-cell:not(:last-child)::after {
		border: none;
	}

	.wholesubmit .duig .van-cell .duig-title div:nth-child(1) {
		margin-right: 1rem;
		color: #6e6e6e;
	}

	.wholesubmit .duig .duig-top {
		text-align: left;
		padding: 0.5rem 0 0.5rem 0.8rem;
		border-bottom: 1px solid #ebedf0;
		font-size: 0.9rem;
		font-weight: bold;
		background: #f7f8fa;
	}

	.wholesubmit .duig .duig-foot {
		color: #828282;
		font-size: 0.8rem;
		transform: scale(0.9);
		text-align: left;
		padding: 0.5rem 0;
		border-top: 1px solid #ebedf0;
		line-height: 1.5625rem;
	}

	.wholesubmit .duig .duig-foot span {
		color: #F1452F;
	}

	.wholesubmit .duig .duig-btn {
		margin: 0.8rem 0;
		display: flex;
		justify-content: space-around;
		width: 90%;
		margin: auto;
	}

	.wholesubmit .duig .duig-btn button {
		padding: 0 2rem;
		height: 1.8rem;
		line-height: 1.8rem;
		width: 40%;
		margin: 0 0 0.625rem 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/wholesubmit/wholesubmit.vue